import { useHistory } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button, Collapse, Divider, Typography } from "@mui/material";

import { useLocalStorage } from "../../../Components/hooks/storageHooks";
import useRouteMatchURL from "../../../Components/hooks/useRouteMatchURL";
import { useAuthContext } from "../../../Context/AuthContext";
import HeaderSummary from "./HeaderSummary";

const CREATE_CUSTOM_INSIGHT = "Create insight";

type Props = {
  permissionsCoverage: number;
  onCoverageClick: () => void;
};

const Header: React.FC<Props> = ({ permissionsCoverage, onCoverageClick }) => {
  const [expanded, setExpanded] = useLocalStorage<boolean>("insights-summary-expanded", true);

  const { isDoitEmployee } = useAuthContext({ mustHaveUser: true });

  const history = useHistory();
  const routeMatchURL = useRouteMatchURL();

  const handleCreateInsightClick = () => {
    history.push(`${routeMatchURL}/new-insight`);
  };

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, flexWrap: "wrap" }}>
          <Box sx={{ flex: 1, minWidth: 300 }}>
            <Typography variant="h1" sx={{ mb: 1 }} data-cy="insights-title">
              Insights
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 400 }} data-cy="insights-description">
                Get data-driven recommendations to optimize resources, mitigate risks, and improve overall cloud
                efficiency.&nbsp;&nbsp;
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={() => {
                  setExpanded(!expanded);
                }}
              >
                <Typography variant="body1" color="primary" sx={{ fontWeight: 400 }}>
                  {expanded ? "Hide summary" : "Show summary"}
                </Typography>
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                    ml: 0.5,
                    fontSize: 20,
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ alignSelf: "flex-end" }}>
            {isDoitEmployee && (
              <Button
                size="medium"
                variant="contained"
                color="primary"
                onClick={handleCreateInsightClick}
                sx={{ whiteSpace: "nowrap" }}
              >
                {CREATE_CUSTOM_INSIGHT}
              </Button>
            )}
          </Box>
        </Box>

        <Collapse in={expanded}>
          <HeaderSummary permissionsCoverage={permissionsCoverage} onCoverageClick={onCoverageClick} />
        </Collapse>
      </Box>
      <Divider sx={{ mb: 4 }} />
    </Box>
  );
};

export default Header;
